import React, { Component, Fragment } from 'react';
import { MenuItem } from '@mui/material';
import { withStyles } from '@mui/styles';
import { NavLink } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import { COLORS } from '../../../utils/Application_Constants';
import msSalService from '../../../services/msSalService';
import UserContext from '../../../contexts/userContext';
import { menuNavigationProps } from '../../../types/centralizedProps';

const styles = () => ({
    menuListRoot: {
        display: 'flex',
    },
    logoWrapper: {
        maxWidth: '243px',
    },
    supportNumberMenuListRoot: {
        display: 'flex',
        marginLeft: '80px',
        paddingLeft: '5px',
    },
    navbarWrapper: {
        padding: '0 28px 0 28px',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        color: `${COLORS.DENIM}`,
    },
    fontBoldHeader: {
        fontWeight: '700',
    },
    paperPopper: {
        zIndex: '1302',
    },
    subNavRoot: {
        fontWeight: '700',
        color: `${COLORS.TRUE_BLUE}`,
        fontSize: '14px',
        '&:hover': {
            background: COLORS.TRUE_BLUE,
            color: '#ffffff',
        },
    },
    gridFlexWrapper: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
    supportNavNumber: {
        fontWeight: '700',
        color: COLORS.TRUE_BLUE,
        fontSize: '16px',
        cursor: 'pointer',
    },
    initials: {
        color: 'white',
        fontWeight: '700',
        backgroundColor: COLORS.TRUE_BLUE,
        width: '30px',
        height: '30px',
        fontSize: '14px',
    },
    initialsButton: {
        padding: '12px 0px 12px 12px',
        '&:hover': {
            background: 'none',
        },
    },
});

class ProfileNavComponent extends Component {
    constructor(props, context) {
        super(props);
        this.context = context;
        this.state = {
            anchorEl: null,
        };
    }

    getInitials(name) {
        let initials = name.match(/\b\w/g) || [];
        initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
        return initials;
    }

    authenticationLogOut = async () => {
        this.handleClose();
        localStorage.removeItem('LocalStorage_UserSignedIN');
        localStorage.removeItem('LocalStorage_FirstTimeUserLogin');
        localStorage.removeItem('LocalStorage_PersonalInfoDisclaimerAlert');
        localStorage.removeItem('snoozeNotification');

        try {
            msSalService.setInitialRedirectUri();
            await msSalService.logOut();
        } catch (error) {
            Error(error);
        }
    };

    navigationItemMenuLinks = (item) => {
        const { classes } = this.props;

        // const reset_password_link = encodeURI(`${process.env.REACT_APP_B2C_BASE_URI}/b2c_1_password_reset/oauth2/v2.0/authorize?response_type=id_token&scope=openid profile&client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${window.location.origin}&nonce=dummy&state=12345&client_info=1&x-client-SKU=MSAL.JS&x-client-Ver=1.2.1&response_mode=fragment`)

        if (item.id === 2 || item.id === 3 || item.id === 4) {
            return (
                <NavLink exact key={item.id.toString()} to={{ pathname: item.link }}>
                    <MenuItem classes={{ root: classes.subNavRoot }} onClick={this.handleClose}>
                        {item.name}
                    </MenuItem>
                </NavLink>
            );
        }

        if (item.id === 5) {
            return (
                <MenuItem
                    key={item.id}
                    classes={{ root: classes.subNavRoot }}
                    onClick={this.authenticationLogOut}
                >
                    {item.name}
                </MenuItem>
            );
        }
    };

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    renderMenu(navigationItem) {
        const { classes, clinician, clinicianInitialLoading } = this.props;
        const { account } = this.context || {};
        const { anchorEl } = this.state;
        let initials = clinician?.initials || '';
        if (
            this.context !== null &&
            account !== null &&
            !clinicianInitialLoading &&
            initials === ''
        ) {
            const rawName =
                clinician?.displayName ||
                `${account.idTokenClaims.given_name} ${account.idTokenClaims.family_name}`;
            initials = this.getInitials(rawName);
        }
        return (
            <div>
                <IconButton
                    className={classes.initialsButton}
                    aria-label="show 17 new notifications"
                    color="inherit"
                    onClick={this.handleClick}
                    size="large"
                >
                    <Avatar className={classes.initials}>{initials}</Avatar>
                </IconButton>
                <span className="caret" />
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    {navigationItem.children.map((item) => this.navigationItemMenuLinks(item))}
                </Menu>
            </div>
        );
    }

    renderMenuItem() {
        const { profileNavigation } = this.props;

        return profileNavigation.map((item) => {
            if (item.children.length > 0) {
                return <Fragment key={item.id}>{this.renderMenu(item)}</Fragment>;
            }
            return null;
        });
    }

    render() {
        return this.renderMenuItem();
    }
}

ProfileNavComponent.propTypes = {
    profileNavigation: menuNavigationProps.isRequired,
};

ProfileNavComponent.contextType = UserContext;
export default withStyles(styles)(ProfileNavComponent);
